import { DATA_STYLE,HEADER_STYLE, SUBHEADER_STYLE } from "../excelReportStyles";
import { addBordersToSheet,formatPlantTrainName } from "../excelReportUtils";

import { formatDate } from "../../../../utils/Utils";

export const createBenchmarkCIPPredictRecommendSheet = (sheet, trainsData, t) => {
  if (!Array.isArray(trainsData) || trainsData.length === 0) {
    return;
  }

  const allDates = new Set();
  trainsData.forEach((train) => {
    const ca = train?.ca_predictions;
    ca?.recommended_cip_start_date?.forEach((date) => allDates.add(date));
    ca?.predicted_cip_start_date?.forEach((date) => allDates.add(date));
  });

  const sortedDates = Array.from(allDates).sort();

  const headerRow1 = sheet.getRow(1);
  headerRow1.getCell(1).value = t("benchMark.headers.startDate");
  Object.assign(headerRow1.getCell(1), HEADER_STYLE);

  const trainColMap = {};
  let colIndex = 2;
  trainsData.forEach((train, trainIdx) => {
    trainColMap[trainIdx] = colIndex;
    const trainNameCell = headerRow1.getCell(colIndex);
    trainNameCell.value = formatPlantTrainName(
      train.plant_name,
      train.plant_id,
      train.train_num,
    );
    Object.assign(trainNameCell, HEADER_STYLE);
    sheet.mergeCells(1, colIndex, 1, colIndex + 3);
    colIndex += 4;
  });

  const headerRow2 = sheet.getRow(2);
  headerRow2.getCell(1).value = "";
  colIndex = 2;
  trainsData.forEach(() => {
    [
      t("benchMark.headers.predictType"),
      t("benchMark.headers.reason"),
      t("benchMark.headers.recommendType"),
      t("benchMark.headers.recommendReason"),
    ].forEach((header) => {
      const cell = headerRow2.getCell(colIndex++);
      cell.value = header;
      Object.assign(cell, SUBHEADER_STYLE);
    });
  });
  headerRow2.commit();

  sortedDates.forEach((date, dateIdx) => {
    const row = sheet.getRow(3 + dateIdx);
    row.getCell(1).value = formatDate(date);
    Object.assign(row.getCell(1), DATA_STYLE);

    trainsData.forEach((train, trainIdx) => {
      const startCol = trainColMap[trainIdx];
      const ca = train.ca_predictions || {};
      const predictedIdx = ca.predicted_cip_start_date
        ? ca.predicted_cip_start_date.findIndex((d) => d === date)
        : -1;
      const recommendedIdx = ca.recommended_cip_start_date
        ? ca.recommended_cip_start_date.findIndex((d) => d === date)
        : -1;

      const values = [
        predictedIdx >= 0 && ca.predicted_cip_types?.[predictedIdx]
          ? ca.predicted_cip_types[predictedIdx]
          : "-",
        predictedIdx >= 0 && ca.predicted_cip_reason?.[predictedIdx]
          ? ca.predicted_cip_reason[predictedIdx]
          : "-",
        recommendedIdx >= 0 && ca.recommended_cip_type?.[recommendedIdx]
          ? ca.recommended_cip_type[recommendedIdx]
          : "-",
        recommendedIdx >= 0 && ca.recommend_cip_reason?.[recommendedIdx]
          ? ca.recommend_cip_reason[recommendedIdx]
          : "-",
      ];

      values.forEach((value, offset) => {
        const cell = row.getCell(startCol + offset);
        cell.value = value;
        Object.assign(cell, DATA_STYLE);
      });

      row.getCell(startCol + 3).alignment = { wrapText: true };
    });

    row.commit();
  });

  sheet.getColumn(1).width = 15;
  trainsData.forEach((_, trainIdx) => {
    const startCol = trainColMap[trainIdx];
    sheet.getColumn(startCol).width = 12;
    sheet.getColumn(startCol + 1).width = 20;
    sheet.getColumn(startCol + 2).width = 12;
    sheet.getColumn(startCol + 3).width = 20;
  });

  addBordersToSheet(sheet);
};
